<div [formGroup]="taskForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="title"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.taskName.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.taskName.label' | translate">
  </nx-edit-text-input>
  <nx-edit-dateTime-input-v2
    formControlName="dueDateTimePeriod"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.dueDate.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.dueDate.label' | translate">
  </nx-edit-dateTime-input-v2>
  <nx-edit-linked-location-input
    formControlName="locationId"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.location.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.location.label' | translate">
  </nx-edit-linked-location-input>
  <nx-edit-time-entries-input
    (refetch)="refetch()"
    *ngIf="task"
    [task]="task"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.timeTracking.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.timeTracking.label' | translate">
  </nx-edit-time-entries-input>
  <nx-edit-linked-address-input
    formControlName="address"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.address.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.address.label' | translate">
  </nx-edit-linked-address-input>
  <nx-edit-linked-contact-input
    formControlName="contact"
    [emptyMessage]="'tourPlanningModule.taskDialogComponent.form.contact.emptyMessage' | translate"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.contact.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.contact.label' | translate">
  </nx-edit-linked-contact-input>
  <nx-edit-linked-resources-input
    formControlName="ressources"
    [emptyMessage]="'tourPlanningModule.taskDialogComponent.form.resources.emptyMessage' | translate"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.resources.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.resources.label' | translate">
  </nx-edit-linked-resources-input>
  <nx-textfield-input
    formControlName="description"
    [showLabel]="false"
    [placeholder]="'tourPlanningModule.taskDialogComponent.form.description.placeholder' | translate"
    [label]="'tourPlanningModule.taskDialogComponent.form.description.label' | translate">
  </nx-textfield-input>
<div>